const SubscribeFormSuccess = () => (
  <div className="c7-subscribe-message">
    <h3>Thank you!</h3>
    <p>You have been added to our mailing list!</p>
  </div>
);

export default SubscribeFormSuccess;
